// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='customer-deposit-accounts-check-deposit' class="box">
  <sub-header header="'Check placement'"></sub-header>

    <!-- Product information -->
    <!-- TODO = this should be extracted as component -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">
          {{\$ctrl.termDeposit.productName}}
        </span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.depositAccount.balance > 0, 'currency--negative': \$ctrl.depositAccount.balance < 0}">
          {{\$ctrl.termDeposit.balance | nxCurrency}}
        </span>
      </div>
      <div class="info-detail">
        <span class="key">Outstanding placement fees:</span>
        <span class="value currency--negative">
            {{\$ctrl.termDeposit.placementFeeBalance | nxCurrency}}
          </span>
      </div>
    </div>

    <!-- Operation form -->

    <form name="\$ctrl.transactionForm">
      <check-form
        class="no-print"
        check-model="\$ctrl.checkModel"
        product-id="\$ctrl.depositId"
        entry-type="'CREDIT'"
        disable-amount-input="false"
        on-us-check-allowed="true">
      </check-form>


      <div class="buttons">
        <button class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-success"
                ng-click="\$ctrl.deposit()"
                ng-disabled="\$ctrl.transactionForm.\$invalid || !\$ctrl.termDeposit">
          Place
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/check-placement/term-deposit-check-placement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;